import { Format, StyleColor } from '../../utils/styles-constants';
import { styled, component } from '../../utils/style';

export const Input = styled()(component.input, 'Input') `
	outline: none;
	background-color: ${StyleColor.White};
	border-radius: 4px;
	border: 1px solid ${StyleColor.Grey300};
	color: ${StyleColor.Grey700};
	font-size: 14px;
	height: 48px;
	margin: 0;
	padding: 0 20px;
	width: calc( 100% - 40px - 2px );
	font-family: inherit;

	&:focus,
	&:hover {
		border-color: ${StyleColor.Grey700};
	}

	&::placeholder {
		font-family: inherit;
		color: ${StyleColor.Grey300};
	}
`;

export const TextArea = styled()(component.textarea, 'TextArea') `
	outline: none;
	background-color: ${StyleColor.White};
	border-radius: 4px;
	border: 1px solid ${StyleColor.Grey300};
	color: ${StyleColor.Grey700};
	font-size: 14px;
	height: 68px;
	margin: 0;
	padding: 20px 20px;
	width: calc( 100% - 40px - 2px );
	font-family: inherit;
	resize: none;

	overflow: auto;//IE override

	&:focus,
	&:hover {
		border-color: ${StyleColor.Grey700};
	}

	&::placeholder {
		font-family: inherit;
		color: ${StyleColor.Grey300};
	}

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-top: 10px;
	}
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/styles.ts